import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "shape",
				"id": "ocCU_VvBIf",
				"left": 199.86947556615024,
				"top": 102.867503352205,
				"width": 208.58164481525625,
				"height": 312.1275327771156,
				"viewBox": [
					208.58164481525625,
					312.1275327771156
				],
				"path": "M 0 26.072705601907032 Q 0 0 26.072705601907032 0 L 182.5089392133492 0 Q 208.58164481525625 0 208.58164481525625 26.072705601907032 L 208.58164481525625 312.1275327771156 L 0 312.1275327771156 Z",
				"fill": "rgba(223,164,127,1)",
				"fixedRatio": false,
				"rotate": 90,
				"pathFormula": "roundRectSameSide",
				"keypoint": 0.125,
				"flipV": true,
				"flipH": true
			},
			{
				"type": "shape",
				"id": "8tPCUBhcGR",
				"left": 499.25506555423135,
				"top": 11.240566522646025,
				"width": 149.7318235995232,
				"height": 495.38140643623353,
				"viewBox": [
					149.7318235995232,
					495.38140643623353
				],
				"path": "M 0 29.145560190703215 Q 0 0 29.145560190703215 0 L 120.58626340882 0 Q 149.7318235995232 0 149.7318235995232 29.145560190703215 L 149.7318235995232 495.38140643623353 L 0 495.38140643623353 Z",
				"fill": "rgba(165,182,196,1)",
				"fixedRatio": false,
				"rotate": -90,
				"pathFormula": "roundRectSameSide",
				"keypoint": 0.19465174129353235,
				"flipV": true,
				"flipH": true
			},
			{
				"type": "shape",
				"id": "Z7zUAbNvZo",
				"left": 251.93682955899885,
				"top": 184.43782516388558,
				"width": 148.98688915375448,
				"height": 148.98688915375448,
				"viewBox": [
					200,
					200
				],
				"path": "M 150 0 A 50 100 0 1 1 150 200 L 0 200 A 50 100 0 0 0 0 0 L 150 0 Z",
				"fill": "rgba(223,164,127,1)",
				"fixedRatio": false,
				"rotate": -180
			},
			{
				"type": "text",
				"id": "GMafIK_mrZ",
				"width": 168.23,
				"height": 68.984375,
				"left": 185.70025625744938,
				"top": 224.4390822407628,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 48.98px;font-family: +mj-ea;\">${serial}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "ujuhNOfqfY",
				"width": 391.2,
				"height": 68.984375,
				"left": 373.0667342073898,
				"top": 224.4390822407628,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 48.98px;font-family: +mj-ea;\">${title}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	};

}